import { render, staticRenderFns } from "./BeneficioFuneralModal.vue?vue&type=template&id=5bb6bde8&scoped=true&"
import script from "./BeneficioFuneralModal.vue?vue&type=script&lang=js&"
export * from "./BeneficioFuneralModal.vue?vue&type=script&lang=js&"
import style0 from "./BeneficioFuneralModal.vue?vue&type=style&index=0&id=5bb6bde8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb6bde8",
  null
  
)

export default component.exports